export default __webpack_public_path__ + "static/media/BisleViewPoint.bb56afca.jpg";